import Api from './api';

const slug = 'v1/videos';
export default {
  uploadVideoMetadata(video) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/`, video)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  getUserVideos(params) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/`, {
        params,
      })
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  getProgramVideos(programSlug, params) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/${programSlug}/search`, { params })
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  getSharedVideos(params) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/shared_with_me`, {
        params,
      })
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  shareVideo(video, userIds, programIds, visibility, sharedLinks) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/share/${video._id}`, {
        users_shared_with: userIds,
        programs_shared_with: programIds,
        visibility: visibility || 'Private',
        shared_links: sharedLinks || [],
      })
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  getUserVideo(id) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/${id}`, {})
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getVideoURL(id) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/url/${id}`, {})
        .then((url) => {
          resolve(url);
        }).catch((err) => {
          reject(err);
        });
    });
  },
  getPublicVideo(id) {
    return new Promise((resolve, reject) => {
      Api.get(`/videos-embed/${id}`, {})
        .then((url) => {
          resolve(url);
        }).catch((err) => {
          reject(err);
        });
    });
  },
  archiveVideo(video) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/update/${video._id}`, {
        ...video,
        status: 'Archived',
      })
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateVideo(video) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/update/${video._id}`, video)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  analyzeVideo(video) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/analyze/${video._id}`, video)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  getImpactScores(videoId) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/${videoId}/impact-scores`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  generateSignedUrl(videoId, expiresIn) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/signed-url/${videoId}`, { expires_in: expiresIn })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
};
